import { render } from "./AccountTooltip.vue?vue&type=template&id=35353945&ts=true"
import script from "./AccountTooltip.vue?vue&type=script&lang=ts"
export * from "./AccountTooltip.vue?vue&type=script&lang=ts"

import "./AccountTooltip.vue?vue&type=style&index=0&id=35353945&lang=scss"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__